import { createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  userMobile: '',
  loading: false,
  isMobileView: false,
  displayWidth: 0,
  notificationCount: 0,
  isUserAuthenticated: false,
  profileImage: '',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
